module.exports = __webpack_public_path__ + "img/United States.4d13d143.png";